import { ServiceBase } from "../core";
import { ApiParams } from "../types";

interface IFeedbackData {
  webpage_id: string;
  webpage_title: string;
  webpage_url: string;
  email: string;
  message: string;
  phone: string;
}

interface ISearchParams {
  states: string;
  groups: string;
  q: string;
  sort_by: string;
  sort_dir: string;
  offset: number;
  limit: number;
}

class SearchService extends ServiceBase {
  public static async sendFeedbackForm(formData: IFeedbackData) {
    const data: ApiParams = {
      method: "POST",
      url: "/inquiries",
      data: formData,
    };
    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getCategories() {
    const data: ApiParams = {
      method: "GET",
      url: "/product-groups?types=bond_category",
    };

    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async getStates() {
    const data: ApiParams = {
      method: "GET",
      url: "/product-groups?types=bond_state",
    };

    const response = await ServiceBase.callApi(data);

    return response;
  }

  public static async searchBond(params: ISearchParams) {
    const {
      states = "",
      groups = "",
      q,
      sort_by = "name,state_code",
      sort_dir = "ASC,ASC",
      offset = 0,
      limit = -1,
    } = params;

    const data: ApiParams = {
      method: "GET",
      url: "/products",
      params: {
        states,
        groups,
        q,
        sort_by,
        sort_dir,
        offset,
        limit,
      },
    };

    // GIGSBM-683-products-api-changes
    // Don't make the api call if there are no search params
    if(q == "" && states == "" && groups == "") {
      return {
        "total_count": 0,
        "data": {
          "products": []
        }
      };
    }
    
    const response = await ServiceBase.callApi(data);

    return response;
  }
}

export default SearchService;
